export enum RacingLicenseCategoryEnum {
    National = 1,
    International = 2
}
